export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '时点日期',
          dataIndex: 'date',
        },
        // {
        //   title: 'CCA',
        //   dataIndex: 'creditControlArea',
        // },
        {
          title: 'Total AR',
          dataIndex: 'arAmount',
          scopedSlots: { customRender: 'arAmount' },
        },
        {
          title: 'Total AP+GR(RMB)',
          width: 170,
          dataIndex: 'grAmountRmbHandle',
          scopedSlots: { customRender: 'grAmountRmbHandle' },
        },
        {
          title: 'Total AP+GR(USD)',
          width: 150,
          dataIndex: 'grAmountUsdHandle',
          scopedSlots: { customRender: 'grAmountUsdHandle' },
        },
        {
          title: 'AP(RMB)',
          dataIndex: 'apAmountRmb',
          scopedSlots: { customRender: 'apAmountRmb' },
        },
        {
          title: 'AP(USD)',
          dataIndex: 'apAmountUsd',
          scopedSlots: { customRender: 'apAmountUsd' },
        },
        {
          title: 'GR(RMB)',
          dataIndex: 'grAmountRmb',
          scopedSlots: { customRender: 'grAmountRmb' },
        },
        {
          title: 'GR(USD)',
          dataIndex: 'grAmountUsd',
          scopedSlots: { customRender: 'grAmountUsd' },
        },
        {
          title: '未清来款',
          dataIndex: 'amountReceipt',
          scopedSlots: { customRender: 'amountReceipt' },
        },
        {
          title: 'Net AR',
          dataIndex: 'netAr',
          scopedSlots: { customRender: 'netAr' },
        },
        {
          title: '集团 Net AR',
          dataIndex: 'groupNetAr',
          scopedSlots: { customRender: 'groupNetAr' },
        },
        {
          title: '尚未逾期(元)',
          dataIndex: 'notOverdue',
          scopedSlots: { customRender: 'notOverdue' },
        },
        {
          title: '逾期1-30D',
          dataIndex: 'overdueOne',
          scopedSlots: { customRender: 'overdueOne' },
        },
        {
          title: '逾期1-30D%',
          dataIndex: 'overdueOneRate',
        },
        {
          title: '逾期31-60D',
          dataIndex: 'overdueThirty',
          scopedSlots: { customRender: 'overdueThirty' },
        },
        {
          title: '逾期31-60D%',
          dataIndex: 'overdueThirtyRate',
        },
        {
          title: '逾期61-90D',
          dataIndex: 'overdueSixty',
          scopedSlots: { customRender: 'overdueSixty' },
        },
        {
          title: '逾期61-90D%',
          dataIndex: 'overdueSixtyRate',
        },
        {
          title: '逾期91-180D',
          dataIndex: 'overdueNinety',
          scopedSlots: { customRender: 'overdueNinety' },
        },
        {
          title: '逾期91-180D%',
          dataIndex: 'overdueNinetyRate',
        },
        {
          title: '逾期大于180D',
          dataIndex: 'overdueHundredEighty',
          scopedSlots: { customRender: 'overdueHundredEighty' },
        },
        {
          title: '逾期大于180D%',
          dataIndex: 'overdueHundredEightyRate',
        },
        {
          title: '货币',
          dataIndex: 'localCurrency',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
